module.exports = {"140223100":"壶泉镇","140223101":"南村镇","140223200":"一斗泉乡","140223202":"蕉山乡","140223203":"加斗乡","140223206":"宜兴乡","140223207":"作疃乡","140223209":"梁庄乡","140223211":"望狐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140223.json
// module id = 279
// module chunks = 0